import { render, staticRenderFns } from "./trainee.statistic.vue?vue&type=template&id=1929f84c&scoped=true&"
import script from "./trainee.statistic.vue?vue&type=script&lang=ts&"
export * from "./trainee.statistic.vue?vue&type=script&lang=ts&"
import style0 from "./trainee.statistic.vue?vue&type=style&index=0&id=1929f84c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1929f84c",
  null
  
)

export default component.exports